'use strict';

var Collection = require('base/Colido.Collection');
var CurrencyModel = require('../models/currency');

/**
 * Collection for the currencies
 *
 * @category   Collection
 * @module     global
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */
var CurrenciesCollection = Collection.extend({
    api: '/core/currencies',
    name: 'global:currencies',
    model: CurrencyModel,
});

module.exports = CurrenciesCollection;